import { createRouter, createWebHistory } from 'vue-router';

import ToolList from "@/views/Tools";
import Benchmark from "@/views/Benchmark";
import Testing from "@/views/Testing";
import HomeView from "@/views/HomeView";
import BenchmarkDetail from "@/views/BenchmarkDetail";
const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/Home',
    name: 'Home',
    component: HomeView
  },

  {
    path: '/Tools',
    name: 'ToolList',
    component: ToolList
  },
  {
    path: '/Benchmark',
    name: 'Benchmark',
    component: Benchmark
  },
  {
    path: '/Testing',
    name: 'Testing',
    component: Testing
  },
  {
    path: '/Benchmark/Detail',
    name: 'BenchmarkDetail',
    component: BenchmarkDetail
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

export default router
